'use client';

import { useSearchParams } from 'next/navigation';

export const useAffiliateFromUrl = (): string | null => {
  const searchParams = useSearchParams();

  return searchParams.get('id_afiliado') ?? searchParams.get('referral');
};
